import styled from "styled-components";
import {
  whiteBgOnClickAnim,
  scaleOnClickAnim,
  textClickAnim,
  OPboxInAnim,
  OPboxOutAnim,
} from "../../animations";

export const Box = styled.div`
  padding: 30px;
  width: 375px;
  /* max-height: 667px; */
  height: 667px;
  margin: auto;
  animation: ${(p) => (p.aboveAnim ? OPboxInAnim : OPboxOutAnim)};
  animation-duration: 0.333s;
  animation-fill-mode: forwards;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const Header = styled.div`
  /* font-size: 30px; */
  font-size: 36px;
  text-align: center;
  div {
    position: relative;
    width: 100%;
    max-width: 256px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input {
    width: 100%;
    background: transparent;
    border: none;
    color: #ffb000;
    outline: none;
    font-size: 23px;
    text-align: center;
    position: relative;
    ::placeholder {
      color: #ffb000;
    }
  }
  span {
    width: 3px;
    height: 30px;
    bottom: 0;
    right: 0;
    background: #ffb000;
    position: absolute;
    bottom: 50%;
    transform: translateY(50%) scale(1);
    opacity: 0;
  }

  @media only screen and (min-width: 375px) {
    font-size: 36px;
  }
`;
export const Button = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #ff3920;
  text-transform: uppercase;
  font-size: 20px;
  cursor: pointer;
  position: relative;
  animation: ${(p) => (p.set ? scaleOnClickAnim : null)};
  animation-duration: 0.333s;
  animation-fill-mode: forwards;
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};

  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) => (p.set ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
  @media only screen and (min-width: 375px) {
    height: 56px;
    /* margin-top: 130px; */
  }
`;

export const BackBtn = styled.div`
  font-size: 20px;
  color: #ffb000;
  text-transform: uppercase;
  text-align: center;
  margin-top: 24px;
  cursor: pointer;
  animation: ${(p) => (p.backBtn ? textClickAnim : null)};
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};
`;

export const BtnGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto;
  /* margin: auto; */
`;
export const Btn = styled.div`
  /* width: 48px;
  height: 48px; */
  height: 56px;
  width: 56px;
  font-size: 20px;
  border-radius: 38px;
  border: solid 2.5px #ffb000;
  background: #ffb000;
  color: #ff3920;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 18px; */
  text-transform: uppercase;
  animation: ${(p) =>
    p.divide || p.double || p.fiveX ? scaleOnClickAnim : null};
  animation-duration: 0.333s;
  animation-fill-mode: forwards;
  position: relative;
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};

  ${(p) =>
    p.plusPress || p.minusPress
      ? "transform: scale(0.65); transition-timing-function: cubic-bezier(0.33, 0, 0, 1); transition: transform 0.1665s;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0, 0, 0, 1); transition: transform 0.1665s;"}
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) =>
      p.divide || p.double || p.fiveX ? whiteBgOnClickAnim : null};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    ${(p) =>
      p.plusPress || p.minusPress
        ? "opacity: 0.5;  transition-timing-function: cubic-bezier(0.17, 0.17, 0.2, 1); trantision: opacity 0.25s;"
        : "opacity: 0;  transition-timing-function: cubic-bezier(0.17, 0.33, 0.2, 1); transition: opacity 0.25s"}
  }
  svg {
    /* height: 24px;
    width: 24px; */
    height: 28px;
    width: 28px;
  }
  @media only screen and (min-width: 375px) {
    /* height: 56px;
    width: 56px;
    font-size: 20px;
    svg {
      height: 28px;
      width: 28px;
    } */
  }
`;
